import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getCookie, CookieName } from "../utils/cookieManager";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Config } from "../utils/Config";
import Snackbar from "@material-ui/core/Snackbar";
import { setTripsActiveMenu } from "../actions/main.js";
import { resetStore } from "../actions/main";
import ReactGA from "react-ga";
ReactGA.initialize("UA-42096921-3");

const styles = () => ({
  root: {
    backgroundColor: "#43A64E !important"
  },
  tabsRoot: {
    borderBottom: "1px solid #BE2538"
  }
});

class Trips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      trips: []
    };
  }

  componentDidMount() {
    if (!getCookie(CookieName.USERTOKEN)) {
      this.props.reset();
    } else {
      this.fetchTrips();
    }
  }

  componentWillUnmount = () => this.abortController.abort();
  abortController = new window.AbortController();

  openSnackBar = message => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({ isSnackBarOpen: true, message: msg });
  };

  handleClose = () => {
    this.setState({ isSnackBarOpen: false });
  };

  fetchTrips() {
    this.setState({ isLoading: true });
    const authToken = getCookie(CookieName.USERTOKEN);

    const url = `${Config.SECURED_API_HOST}/api/platform/bus/allbusbookings?authToken=${authToken}`;
    fetch(url, { signal: this.abortController.signal })
      .then(res => res.json())
      .then(res => {
        this.setState({ trips: res.bookings, isLoading: false });
        console.log(res);
      })
      .catch(error => {
        if (error.name === "AbortError") {
          console.error("Fetch aborted");
        } else {
          this.openSnackBar("Something went wrong, Please try again later.");
          console.error("Error:", error);
        }
      });
  }

  handleChangeTab = (event, value) => {
    debugger;
    this.props.setTripsActiveMenu(value);
  };

  render() {
    const header = (
      <div className="header">
        <Grid container justify="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={10}>
            <div className="from">
              <span> My Trips</span>
            </div>
          </Grid>
        </Grid>
      </div>
    );

    // bookingid: "141127210023988032"
    // destination: "VIJAYAWADA"
    // email: "asteroidin@gmail.com"
    // fare: "Rs 270"
    // isUpComing: false
    // provider: "APSRTC"
    // seats: "19"
    // source: "DILSUKHNAGAR"
    // status: "Booked"
    // time: "24/01/2019"
    // type: "bus"

    const trips = this.state.trips;
    const upcomingTrips = trips.filter(t => {
      var today = t.time.split("/");
      today = new Date(today[2], today[1] - 1, today[0]);
      const dtDiff = new Date(today) - new Date().getTime();
      return t.status !== "Cancelled" && dtDiff > 1;
    });

    const completedTrips = trips.filter(t => {
      var today = t.time.split("/");
      today = new Date(today[2], today[1] - 1, today[0]);
      const dtDiff = new Date(today) - new Date();
      return t.status !== "Cancelled" && dtDiff <= 0;
    });

    const cancelledTrips = trips.filter(t => {
      return t.status === "Cancelled";
    });

    const upcomingTripsBlock = (
      <div>
        {upcomingTrips.length > 0 ? (
          upcomingTrips.map((t, i) => {
            return (
              <div key={i}>
                <Card
                  className="tripCard"
                  onClick={() =>
                    this.props.history.push(
                      `/bus-booking-phonepe/ticket/${t.bookingid}/${t.email}/${t.provider}`
                    )
                  }
                >
                  <CardContent className="cardcontent">
                    <Grid container justify="flex-start">
                      <Grid item xs={1}>
                        <i className="material-icons">directions_bus</i>
                      </Grid>
                      <Grid item xs={5} className="alignCenter">
                        {t.source}
                      </Grid>
                      <Grid item xs={1}>
                        <i className="material-icons">arrow_right_alt</i>
                      </Grid>
                      <Grid item xs={5} className="alignCenter">
                        {t.destination}
                      </Grid>
                    </Grid>
                    <Grid container justify="flex-start">
                      <Grid item xs={6}>
                        Booking ID: {t.bookingid}
                      </Grid>
                      <Grid item xs={6} className="pnr">
                        Fare: {t.fare}
                        <br />
                        Seats :{t.seats}
                      </Grid>
                    </Grid>
                    <div className="date">
                      {new Date(
                        t.time.split("/")[2],
                        t.time.split("/")[1] - 1,
                        t.time.split("/")[0]
                      ).toDateString()}
                    </div>
                  </CardContent>
                </Card>
              </div>
            );
          })
        ) : (
          <div>There are no Upcoming trips. Book Bus tickets with us</div>
        )}
      </div>
    );

    const completedTripsBlock = (
      <div>
        {completedTrips.length > 0 ? (
          completedTrips.map((t, i) => {
            return (
              <div key={i}>
                <Card
                  className="tripCard"
                  onClick={() =>
                    this.props.history.push(
                      `/bus-booking-phonepe/ticket/${t.bookingid}/${t.email}/${t.provider}`
                    )
                  }
                >
                  <CardContent className="cardcontent">
                    <Grid container justify="flex-start">
                      <Grid item xs={1}>
                        <i className="material-icons">directions_bus</i>
                      </Grid>
                      <Grid item xs={5} className="alignCenter">
                        {t.source}
                      </Grid>
                      <Grid item xs={1}>
                        <i className="material-icons">arrow_right_alt</i>
                      </Grid>
                      <Grid item xs={5} className="alignCenter">
                        {t.destination}
                      </Grid>
                    </Grid>
                    <Grid container justify="flex-start">
                      <Grid item xs={6}>
                        Booking ID: {t.bookingid}
                      </Grid>
                      <Grid item xs={6} className="pnr">
                        Fare: {t.fare}
                        <br />
                        Seats :{t.seats}
                      </Grid>
                    </Grid>
                    <div className="date">
                      {new Date(
                        t.time.split("/")[2],
                        t.time.split("/")[1] - 1,
                        t.time.split("/")[0]
                      ).toDateString()}
                    </div>
                  </CardContent>
                </Card>
              </div>
            );
          })
        ) : (
          <div>There are no Completed trips. Book Bus tickets with us</div>
        )}
      </div>
    );

    const cancelledTripsBlock = (
      <div>
        {cancelledTrips.length > 0 ? (
          cancelledTrips.map((t, i) => {
            return (
              <div key={i}>
                <Card
                  className="tripCard"
                  onClick={() =>
                    this.props.history.push(
                      `/bus-booking-phonepe/ticket/${t.bookingid}/${t.email}/${t.provider}`
                    )
                  }
                >
                  <CardContent className="cardcontent">
                    <Grid container justify="flex-start">
                      <Grid item xs={1}>
                        <i className="material-icons">directions_bus</i>
                      </Grid>
                      <Grid item xs={5} className="alignCenter">
                        {t.source}
                      </Grid>
                      <Grid item xs={1}>
                        <i className="material-icons">arrow_right_alt</i>
                      </Grid>
                      <Grid item xs={5} className="alignCenter">
                        {t.destination}
                      </Grid>
                    </Grid>
                    <Grid container justify="flex-start">
                      <Grid item xs={6}>
                        Booking ID: {t.bookingid}
                      </Grid>
                      <Grid item xs={6} className="pnr">
                        Fare: {t.fare}
                        <br />
                        Seats :{t.seats}
                      </Grid>
                    </Grid>
                    <div className="date">
                      {new Date(
                        t.time.split("/")[2],
                        t.time.split("/")[1] - 1,
                        t.time.split("/")[0]
                      ).toDateString()}
                    </div>
                  </CardContent>
                </Card>
              </div>
            );
          })
        ) : (
          <div>There are no Cancelled trips. Book Bus tickets with us</div>
        )}
      </div>
    );

    const q = this.props.searchQuery;
    let display = upcomingTripsBlock;

    if (q.tripsActiveMenu === 1) {
      display = completedTripsBlock;
    }
    if (q.tripsActiveMenu === 2) {
      display = cancelledTripsBlock;
    }

    return (
      <div className="train-list" style={{ padding: "0px" }}>
        {header}
        <div>
          <AppBar position="static" color="default">
            <Tabs
              value={q.tripsActiveMenu}
              onChange={this.handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="UPCOMING" />
              <Tab label="COMPLETED" />
              <Tab label="CANCELLED" />
            </Tabs>
          </AppBar>
          <div className="trips-content">
            {this.state.isLoading ? (
              <div className="loading">
                <CircularProgress />
              </div>
            ) : (
              display
            )}
          </div>
        </div>

        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          autoHideDuration={3500}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchQuery: state.searchReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setTripsActiveMenu: menu => {
      dispatch(setTripsActiveMenu(menu));
    },
    reset: () => {
      dispatch(resetStore());
    }
  };
};

Trips.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Trips));
